import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { http } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const check = useCallback(async () => {
    try {
      const { data } = await http.get("/auth/me");
      setUser(data);
    } catch {
      try {
        const { data } = await http.post("/auth/refresh");
        setUser(data);
      } catch {
        setUser(false);
      }
    }
  }, []);

  useEffect(() => {
    // Returning from Google sign-in: AdminLogin exchanges the session_id first.
    if (window.location.hash?.includes("session_id=")) {
      setUser(false);
      return;
    }
    check();
  }, [check]);

  const login = async (email, password) => {
    const { data } = await http.post("/auth/login", { email, password });
    setUser(data);
  };
  const googleLogin = async (sessionId) => {
    const { data } = await http.post("/auth/google", { session_id: sessionId });
    setUser(data);
  };
  const logout = async () => {
    await http.post("/auth/logout").catch(() => {});
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, login, googleLogin, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
